export default "__VITE_ASSET__B$kzdnmX__ 100w";